module.exports = __webpack_public_path__ + "static/media/marotte.80843662.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/brands/marotte.svg
// module id = 1153
// module chunks = 37